import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendlyComponent } from '../calendly.component';
import { Psychologist } from '../../../models/psychologist.model';

@Component({
  selector: 'app-calendly-modal',
  standalone: true,
  imports: [CommonModule, CalendlyComponent],
  templateUrl: './calendly-modal.component.html',
  styleUrl: './calendly-modal.component.scss',
})
export class CalendlyModalComponent {
  @Input() caregiver: Psychologist | null = null;
  @Input() isOpen = false;
  @Output() close = new EventEmitter<void>();
  @Output() scheduled = new EventEmitter<any>();

  onBackdropClick(event: Event): void {
    if (event.target === event.currentTarget) {
      this.closeModal();
    }
  }

  closeModal(): void {
    this.close.emit();
  }

  onScheduled(event: any): void {
    this.scheduled.emit(event);
    this.closeModal();
  }
}
